import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { setData } from '../../services/store/userSlice';
import { selectUser } from "../../services/store/userSlice";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { pendings } from './data/pending-data';
import { trainingApi } from '../../services';
import { utitService } from '../../services/util';
import Trf from './trf';
import CreateTrfForm from './create-trf-form';
import TrfDetailsView from './trf-details-view';
import Training from './training'
import { Dialog } from 'primereact/dialog';
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import TrainingUserDetailsView from './training-user-details-view';


const TrfList = () => {
    const loginUserData = useSelector(selectUser);
    const [trfHistoryList, setTrfHistoryList] = useState([]);
    const [detailsViewStatus, setdetailsViewStatus] = useState(false);
    const [clickedRowData, setClickedRowData] = useState({});
    const [skillRowData, setSkillRowData] = useState({});
    const [trfEditForm, setTrfEditForm] = useState(false);
    const [isNewTrf, setNewTrf] = useState(false);
    const [screen, setScreen] = useState('listing');
    const [visible, setVisible] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [pendingActions, setPendingActions] = useState(pendings);
    const [editedTRFData, setEditedTRFData] = useState([]);
    const [trainingRowData, setTrainingRowData] = useState([]);
    const [trainingDetailsViewStatus, setTrainingDetailsViewStatus] = useState(false);

    useEffect(() => {
        getTrfHistoryList();
    }, []);

    const getTrfHistoryList = () => {
        trainingApi.getManagerTrfHistory().then(resp => {
            // const data = resp.data?.data;
            // const pendings = data.filter(x => x.status === 4 || x.status === 5 || x.status === 6);
            const pendings = resp?.data?.data.filter(x => x.status === 4 || x.status === 5 || x.status === 6);
            const pendingData = pendings.filter(xx => xx.userId != loginUserData?.id);
            setTrfHistoryList(pendingData);
        }).catch(e => {
        })
    }

    /* Reload After Close Dialog */
    const reloadTrfHistory = () => {
        setdetailsViewStatus(false);
        getTrfHistoryList();
    }
    /* Reload After Close Dialog */

    const actionBody = (rowData) => {
        return (<>
            <Button title="View TRF Form" icon="pi pi-eye" className="p-button-rounded p-button-text" severity="secondary" onClick={() => viewTrfDetails(rowData)} />
            <Button title="Update TRF Form" icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => { setTrfEditForm(true); setScreen('new'); setClickedRowData(rowData) }} disabled={rowData.status === 5 ? true : false} />
            <Button title="Delete TRF Form" icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={(e) => deleteTRFRecord(e, rowData)} disabled={rowData.status === 5 ? true : false} />
        </>)
    }

    /* For View Trf Details of Rsource */
    const viewTrfDetails = (rowData) => {
        setClickedRowData(rowData);
        setdetailsViewStatus(true);
    }
    /* For View Trf Details of Rsource */

    /* Delete Trf Record Start */
    const deleteTRFRecord = (e, rowData) => {
        confirmDialog({
            target: e.currentTarget,
            message: 'Are you sure you want to delete this?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: "p-button-danger",
            acceptLabel: 'No',
            rejectLabel: 'Yes',
            reject: () => {
                try {
                    trainingApi.deleteTrainingFormByID(rowData.id).then(
                        (resp) => {
                            toast.success(resp?.data?.message);
                            getTrfHistoryList();
                        },
                        (err) => {
                            toast.error(err.response.data.error);
                        }
                    );
                } catch (error) {
                    toast.error("Unable to delete");
                }
            },
            accept: () => { }
        });
    }
    /* Delete Trf Record End */

    const trainingIdBody = (rowData) => {
        return (
            <span title="View Training Detail" style={{ cursor: 'pointer', color: 'blue', }} onClick={() => viewTrainingDetails(rowData)}>
                {rowData.id.toString().padStart(7, '0')}
            </span>
        )
    }

    const viewTrainingDetails = (rowData) => {
        setTrainingRowData(rowData);
        setTrainingDetailsViewStatus(true);
    }

    const reloadTrainingHistory = () => {
        setTrainingDetailsViewStatus(false);
        getTrfHistoryList();
    }

    const skillFormData = (data) => {
        setSkillRowData(data);
    }


    return (
        <div className='ess-page'>
            <div className='ess-table bordered-wrapper'>
                <div className='table-header grid'>
                    <div className='col p-0'>
                        <h1 className='m-0 p-0'>
                            {screen === 'new' && !trfEditForm && "New TRF Form"}
                            {screen === 'new' && trfEditForm && "Edit TRF Form"}
                            {screen === 'listing' && 'TRF Form History'}
                            {/* {screen === 'skills' && 'Resource Skill Validation'} */}
                        </h1>
                    </div>
                    <div className='col p-0' style={{ textAlign: 'right' }}>
                        {['new', 'skills'].includes(screen) && <>
                            <Button className='p-button p-button-sm ess-table-button' onClick={() => { setScreen('listing'); setTrfEditForm(false); setClickedRowData({}) }} severity='primary' icon='pi pi-arrow-left' label='TRF History' />
                        </>}
                        {screen === 'listing' && <>
                            <Button className='p-button p-button-sm ess-table-button mr-1' severity='primary' icon='pi pi-filter' />
                            {/* <Button className='p-button p-button-sm ess-table-button mr-1' onClick={() => setScreen('skills')} severity='primary' icon='pi pi-shield' label='Skill Validation' style={{ width: '120px' }} /> */}
                            <Button className='p-button p-button-sm ess-table-button' onClick={() => setScreen('new')} severity='primary' icon='pi pi-plus' label='New TRF Form' style={{ width: '120px' }} />
                        </>}
                    </div>
                </div>
                {screen === 'listing' && <div>
                    <DataTable value={trfHistoryList} stripedRows responsiveLayout="scroll"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                    >
                        <Column field="" header="Training Id" body={trainingIdBody}></Column>
                        <Column field="nameOfNominatedParticipant" header="Resource Name"></Column>
                        {/* <Column field="ecnOfRequester" header="ECN"></Column> */}
                        {/* <Column field="trainingRequisitionDate" header="Requ. Date" body={(r) => (utitService.dateWithMonthConverter(r.trainingRequisitionDate))} ></Column> */}
                        <Column field="startDateOfTraining" header="Exp. Start Date" body={(r) => (utitService.dateWithMonthConverter(r.startDateOfTraining))}></Column>
                        <Column field="endDateOfTraining" header="Exp. End Date" body={(r) => (utitService.dateWithMonthConverter(r.endDateOfTraining))}></Column>
                        <Column field="categoryOfTraining" header="Category" body={(r) => <span className='capitalize'>{r?.categoryOfTrainings?.title}</span>}></Column>
                        <Column field="targetSkills" header="Target Skill" body={(r) => <span className='capitalize'>{r?.targetSkills?.title}</span>}></Column>
                        {/* <Column field="currentTechnology" header="Techonology"></Column> */}
                        <Column field="status" header="Status" body={(rowData) => (utitService.getTrainingStatus(rowData.status))} ></Column>
                        <Column header="Actions" style={{ textAlign: 'center' }} body={actionBody} />
                    </DataTable>
                </div>}
                {screen === 'new' && <div className='p-2'>
                    {/* <Trf parent={true} setNewTrf={setNewTrf} reload={getTrfHistoryList} setScreen={setScreen} /> */}
                    <CreateTrfForm reload={getTrfHistoryList} setNewTrf={setNewTrf} setScreen={setScreen} isEdit={trfEditForm} editTrfForm={clickedRowData} skillFormData={skillRowData} updateClickedRow={() => setClickedRowData({})} />
                </div>}
                {/* {screen === 'skills' && <div className='p-2'>
                    <Training parent={true} setNewTrf={setNewTrf} setScreen={setScreen} reload={getTrfHistoryList} skillValidationData={(data) => skillFormData(data)} />
                </div>} */}
            </div>

            {/* View Trf Fprm details start*/}
            <Dialog className='custom_popup' header="View TRF Details" visible={detailsViewStatus} onHide={() => reloadTrfHistory()} style={{ width: '80vw' }}>
                <TrfDetailsView clickedRowData={clickedRowData} type="normal" />
            </Dialog>
            {/* View Trf Fprm details end*/}

            {/* View Training Details on Trf History */}
            <Dialog className='custom_popup' header="User Training Details" visible={trainingDetailsViewStatus} onHide={() => reloadTrainingHistory()} style={{ width: '80vw' }}>
                <TrainingUserDetailsView clickedRowData={trainingRowData} />
            </Dialog>
            {/* View Training Details on Trf History */}
        </div>
    )
}

export default TrfList;